// extracted by mini-css-extract-plugin
export default {"cookiePreferencesButton":"cookiePreferencesButton_cookiePreferencesButton__MaUD-","image":"cookiePreferencesButton_image__iOpnX"};